import { cssClass } from '@/shared/utils'
import { cardHeaderWithBackground } from '../../styles/noSocialCard.css'
import { Text } from '@/components/commons/typography/Text'
import Image from 'next/image'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'

export const EmptyConnectionCardHeader = () => {
  return (
    <div
      className={cssClass([
        'flex flex-row py-12 px-24 bg-black-primary rounded-t-12 gap-12 gap-24--desktop items-center--desktop',
        cardHeaderWithBackground,
      ])}
    >
      <Text colorClass="text-accent-primary" className="font-bold">
        Creatorland Analytics
      </Text>

      <div className="flex gap-6">
        <Image
          width={20}
          height={20}
          src={IMAGE_PATHS_V2.icons.socials + 'circle/fc/youtube.svg'}
          alt="instagram"
        />
        <Image
          width={20}
          height={20}
          src={IMAGE_PATHS_V2.icons.socials + 'circle/fc/instagram.svg'}
          alt="instagram"
        />
        <Image
          width={20}
          height={20}
          src={IMAGE_PATHS_V2.icons.socials + 'circle/fc/tiktok.svg'}
          alt="instagram"
        />
      </div>
    </div>
  )
}
